// extracted by mini-css-extract-plugin
export default {"navigationMenu":"NavigationLayout_navigationMenu__7DlEn"};